/**
 * @generated SignedSource<<0d4db1d50aad42cb661f70739240ece9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCheckoutCompanyData_company$data = {
  readonly nameFriendly: string | null | undefined;
  readonly taxID: {
    readonly taxID: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PaymentCheckoutCompanyData_company";
};
export type PaymentCheckoutCompanyData_company$key = {
  readonly " $data"?: PaymentCheckoutCompanyData_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutCompanyData_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCheckoutCompanyData_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameFriendly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxID",
      "kind": "LinkedField",
      "name": "taxID",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taxID",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "be4e0a8dffc6f51a19dc8792f94e7fe9";

export default node;
